import script from "./WeeklyCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./WeeklyCalendar.vue?vue&type=script&setup=true&lang=js"

import "./WeeklyCalendar.vue?vue&type=style&index=0&id=7c261dfe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c261dfe"]])

export default __exports__